import { useAppDispatch } from 'src/app/store/hooks';
import {
  VehicleVehicleTagRead,
  useVehicleTagsDestroyMutation,
} from 'src/common/external/bambi-api/bambiApi';
import { toastSlice } from 'src/common/primitives/Toast/toast.slice';
import { TagDisplay } from 'src/common/tags/TagDisplay/TagDisplay';

type VehicleTagDisplayProps = {
  tags?: VehicleVehicleTagRead[] | null;
};

export default function VehicleTagDisplay({
  tags,
}: VehicleTagDisplayProps): JSX.Element | null {
  const dispatch = useAppDispatch();
  const [deleteTag] = useVehicleTagsDestroyMutation();

  return (
    <TagDisplay
      tags={tags}
      onDelete={(tagId) => {
        return deleteTag({
          id: tagId,
        })
          .unwrap()
          .catch(() => {
            dispatch(
              toastSlice.actions.show({
                title: 'Error deleting tag',
                type: 'error',
              })
            );
          });
      }}
    />
  );
}
